// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.perfil[data-v-006a1c3a] {\r\n  padding: 1.5rem;\n}\n.data[data-v-006a1c3a] {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n   padding: 1rem;\n}\n.data >div[data-v-006a1c3a] {\r\n  margin:  0 .2rem;\n}\n.data .imagem_calendar[data-v-006a1c3a]{\r\n    filter: invert(70%) sepia(26%) saturate(8645%) hue-rotate(195deg) brightness(105%) contrast(100%);\n}\r\n", ""]);
// Exports
module.exports = exports;
